import { c as _c } from "react/compiler-runtime";
import Error500 from './Error500';
import { Props } from './ErrorWrapper';
const GenericError = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <Error500 {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export default GenericError;